import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Table1 from "./Table1";
import Openinginvoiceservice from "./Openinginvoiceservice";
const Tab1 = ({
  pageState,
  handleChange,
  onInputChange,
  invoiceList,
  userList,
  CompanyList,
  errors,
  setselected_item_data,

  CostCenterList,
  list_data,
}) => {
  const statusList = [
    { name: "Passive" },
    { name: "Open" },
    { name: "Replied" },
  ];

  return (
    <div>
      <div className=" m-0">
        <Openinginvoiceservice />
      </div>
      <div className="px-3 py-4" style={{ background: "white" }}>
        <div className="mb-3" style={{ display: "flex", gap: "20px" }}>
          <div className="col-md-12" style={{ display: "flex" }}>
            <div className="col-md-6 px-2">
              <div
                className=""
                style={{
                  backgroundColor: "#EBE6FA",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                }}
              >
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <p
                      className="m-0"
                      style={{ fontSize: "16px", fontWeight: "600" }}
                    >
                      Details
                    </p>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CompanyList}
                      label="Company"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.Company}
                      onChange={(val) => handleChange("Company", val)}
                      placeholder=""
                    />
                  </div>

                  <div style={{ display: "flex", gap: "15px" }}>
                    <div style={{ flex: 1 }}>
                      <SelectSearch
                        list={invoiceList}
                        label="InvoiceType"
                        getOptionLabel={(item) => item.name}
                        getOptionValue={(item) => item.name}
                        value={pageState.gender}
                        onChange={(val) => handleChange("InvoiceType", val)}
                        placeholder=""
                      />
                    </div>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={{ height: "19px" }}></label>
                    <Checkbox
                      id="CreateMissingParty"
                      label="CreateMissingParty"
                      checked={pageState.CreateMissingParty || false}
                      onChange={(checked) =>
                        onInputChange("CreateMissingParty", checked)
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 px-2">
              <div
                className=""
                style={{
                  backgroundColor: "#E3F5DF",
                  height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  padding: "10px",
                }}
              >
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <p
                      className="m-0"
                      style={{ fontSize: "16px", fontWeight: "600" }}
                    >
                      Accounting Dimensions
                    </p>
                  </div>
                </div>
                <div className="col-6">
                  <div style={{ flex: 1 }}>
                    <SelectSearch
                      list={CostCenterList}
                      label="CostCenter"
                      getOptionLabel={(item) => item.name}
                      getOptionValue={(item) => item.name}
                      value={pageState.CostCenter}
                      onChange={(val) => handleChange("CostCenter", val)}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div
            className="col-md-12 px-2"
            style={{ display: "flex", gap: "20px" }}
          >
            <div
              className=""
              style={{
                height: "100%",
                borderRadius: "4px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                padding: "10px",
                border: "1px solid #DBDBDB",
                borderRadius: "5px",
              }}
            >
              <div style={{ display: "flex", gap: "15px" }}>
                <div style={{ flex: 1 }}>
                  <p
                    className=""
                    style={{ fontSize: "16px", fontWeight: "600" }}
                  >
                    Invoices
                  </p>
                </div>
              </div>

              <Table1 setselected_item_data={setselected_item_data} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tab1;
